// extracted by mini-css-extract-plugin
export default {"wrapper":"Atlantic_wrapper__cWxTe","heading":"Atlantic_heading__DwijW","grid":"Atlantic_grid__tzt0p"};